import axios from "../axios";

const api = {
  getSupplierNotes(paramsString, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/suppliers/notes?${paramsString}`, config).then(({ data }) => data);
  },
  createSupplierNotes(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/suppliers/notes", data, headers).then(({ data }) => data);
  },
  updateSupplierNotes({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/suppliers/notes/${id}`, data, headers).then(({ data }) => data);
  },
  deleteSupplierNotes(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/suppliers/notes/${id}`, headers).then(({ data }) => data);
  }
};

export default api;